// extracted by mini-css-extract-plugin
module.exports = {"hidden":"Tiptap_hidden__FNfSk","ProseMirror":"Tiptap_ProseMirror__svmPJ","editorButton":"Tiptap_editorButton__HE1cA","editorSubscribeButton":"Tiptap_editorSubscribeButton__u_Wsg"};